<template>
    <div class="contenedor-info">
        <div class="row">
            <div class="col-1">
                <a-button shape="circle" icon="arrow-left" @click="regresar"/>
            </div>
            <div class="col-11">
                <slot name="contenido"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                
            }
        },
        methods: {
            regresar(){
                this.$router.go(-1)
            }
        },
    }
</script>
<style>
    .anticon-arrow-left{
        font-size: 24px;
        color: #475564;
    }
    .ant-btn{
        border: 3px solid #475564;
    }

    .ant-btn:hover{
        border-color: #475564 !important;
        /* background: #475564; */
    }
    .layout-default{
        background: #ffffff !important;
        height: 100vh;
    }
</style>